export enum ExportActionsEnum {
  EXPORT_INIT_PAGE = 'EXPORT_INIT_PAGE',
  EXPORT_GET_DATA = 'EXPORT_GET_DATA',
  EXPORT_GET_DATA_NEXT_PAGE = 'EXPORT_GET_DATA_NEXT_PAGE',
  EXPORT_SET_DATA = 'EXPORT_SET_DATA',
  EXPORT_SET_ORDER = 'EXPORT_SET_ORDER',
  EXPORT_REMOVE = 'EXPORT_REMOVE',
  EXPORT_DOWNLOAD_FILE = 'EXPORT_DOWNLOAD_FILE',
}
